import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loader = () => import( /* webpackChunkName: "SingleReportViewerModalContainer" */'./modal/SingleReportViewerModalContainer');
export default Loadable({
  loader,
  LoadingComponent: () => null
});